




























































import { Component, Vue } from 'vue-property-decorator'
import store from '@/store'
import ResourceSection from '@/components/ResourceSection.vue'
import { Card } from '@alpha/ink'
import PageHeader from '@/components/PageHeader.vue'
var accountManagerJson = require('@/assets/json/accountManager.json')

@Component({
  components: { ResourceSection, Card, PageHeader }
})

export default class Resources extends Vue {
  get clientId () {
    return this.$route.params.workspaceId
  }

  get accountManager () {
    const user = store.state.user.authenticatedUser
    if (!user) { return this.getAccountManager('16') }

    const workspaceId = user.defaultWorkspaceId
    const workspace = user.workspaces.find(workspace => workspace.id === workspaceId)
    if (!workspace) { return this.getAccountManager('16') }

    const amId = workspace.accountManager || '16'
    const accountManager = this.getAccountManager(amId)

    let amObject = ''

    if (!amId || !accountManager || !accountManager.active) {
      amObject = this.getAccountManager('16')
    } else {
      amObject = accountManager
    }

    return amObject
  }

  getHeadshotImg (imagePath:string) {
    return require(`../assets/${imagePath}`)
  }

  get tutorialLink () {
    // Intercom link to demo
    return `/${this.clientId}/?product_tour_id=87465`
  }

  getAccountManager (id:string) {
    return accountManagerJson[id]
  }
}
